import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chep-activity',
  templateUrl: './chep-activity.component.html',
  styleUrls: ['./chep-activity.component.scss']
})
export class ChepActivityComponent implements OnInit, OnDestroy {
  lastPage: boolean;

  private subscriptions: Subscription[];

  constructor() { }

  ngOnInit() {
    this.subscriptions = [
    ];
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach(s => s.unsubscribe());
  }

  lastStep() {
    return true;
  }
}
